import React from 'react';
import { styled } from '@mui/material/styles';

const BackgroundWrapper = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  zIndex: -1,
  background: '#071E37',
  overflow: 'hidden'
});

const EllipseContainer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none'
});

const Ellipse1 = styled('div')({
  position: 'absolute',
  width: '742px',
  height: '715px',
  top: '10%',
  left: '15%',
  background: 'radial-gradient(ellipse, #36C5F0 0%, transparent 70%)',
  filter: 'blur(274.25px)',
  flexShrink: 0,
  opacity: 0.6
});

const Ellipse2 = styled('div')({
  position: 'absolute',
  width: '415px',
  height: '390px',
  top: '25%',
  right: '20%',
  background: 'radial-gradient(ellipse, #36C5F0 0%, transparent 70%)',
  filter: 'blur(179.95px)',
  flexShrink: 0,
  opacity: 0.5
});

const Ellipse3 = styled('div')({
  position: 'absolute',
  width: '215px',
  height: '212px',
  bottom: '30%',
  left: '25%',
  background: 'radial-gradient(ellipse, #0075FF 0%, transparent 70%)',
  filter: 'blur(179.95px)',
  flexShrink: 0,
  opacity: 0.7
});

const Ellipse4 = styled('div')({
  position: 'absolute',
  width: '571.891px',
  height: '537.439px',
  bottom: '15%',
  right: '10%',
  background: 'radial-gradient(ellipse, #00FFFF 0%, transparent 70%)',
  filter: 'blur(231.55px)',
  transform: 'rotate(72.061deg)',
  flexShrink: 0,
  opacity: 0.4
});

const CustomBackground = () => {
  return (
    <BackgroundWrapper>
      <EllipseContainer>
        <Ellipse1 />
        <Ellipse2 />
        <Ellipse3 />
        <Ellipse4 />
      </EllipseContainer>
    </BackgroundWrapper>
  );
};

export default CustomBackground;
